import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import StandardsTable from "../../components/StandardsTable/SAStandardsTable";
import OffSiteStandardsTable from "../../components/StandardsTable/OffSiteStandardsTable";
import EvalReportStandardsTable from "../../components/StandardsTable/EvalReportStandardsTable";
import InterviewStandards from "../InterviewStandards";
import { useTranslation } from "react-i18next";
import LicenceStandardsTable from "../../components/LicenceStandardsTable";

const ClubStandards = () => {
    const currentSection = useSelector((state:any) => state.evaluation.currentEvaluationTab);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);
    const drawer = useSelector((state:any) => state.common.drawer);
    const [t] = useTranslation();

    return(
        <>
            {
                drawer == 'Licence' &&
                <LicenceStandardsTable />   
            }
            {
                !isAdmin &&
                currentSection == t('EVALUATION') &&
                drawer == 'Evaluation' &&
                <StandardsTable />
            }
            {
                isAdmin && 
                currentSection == t('EVALUATION') &&
                drawer == 'Evaluation' &&
                <OffSiteStandardsTable />
            }
            {
                isAdmin && 
                currentSection == t('ON_SITE') &&
                drawer == 'Evaluation' &&
                <InterviewStandards />
            }
            {
                currentSection == t('EVALUATION_REPORT') &&
                drawer == 'Evaluation' &&
                <EvalReportStandardsTable />
            }
        </>
    )
};

export default ClubStandards;